import _ from 'lodash'

export function isLastItem(array: any[], index: number) {
  return _.findLastIndex(array) === index
}
